import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "bodyClassName", "headClassName"];
import classNames from "classnames";
import React from "react";
import { ConfigContext } from "../ConfigProvider";
import SizeContext from "../ConfigProvider/SizeContext";
import omit from "../hack/rc-util/omit";
import Skeleton from "../Skeleton";
import Tabs from "../Tabs";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getAction(actions) {
  var actionList = actions.map(function (action, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _jsx("li", {
        style: {
          width: "".concat(100 / actions.length, "%")
        },
        children: /*#__PURE__*/_jsx("span", {
          children: action
        })
      }, "action-".concat(index))
    );
  });
  return actionList;
}
var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _objectSpread2, _classNames;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var size = React.useContext(SizeContext);
  var onTabChange = function onTabChange(key) {
    var _props$onTabChange;
    (_props$onTabChange = props.onTabChange) === null || _props$onTabChange === void 0 ? void 0 : _props$onTabChange.call(props, key);
  };
  var isContainGrid = function isContainGrid() {
    var containGrid;
    // React.Children.forEach(props.children as any, (element: JSX.Element) => {
    //   if (element && element.type && element.type === Grid) {
    //     containGrid = true;
    //   }
    // });
    return containGrid;
  };
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    extra = props.extra,
    _props$headStyle = props.headStyle,
    headStyle = _props$headStyle === void 0 ? {} : _props$headStyle,
    _props$bodyStyle = props.bodyStyle,
    bodyStyle = _props$bodyStyle === void 0 ? {} : _props$bodyStyle,
    title = props.title,
    loading = props.loading,
    _props$bordered = props.bordered,
    bordered = _props$bordered === void 0 ? false : _props$bordered,
    customizeSize = props.size,
    type = props.type,
    cover = props.cover,
    actions = props.actions,
    tabList = props.tabList,
    children = props.children,
    activeTabKey = props.activeTabKey,
    defaultActiveTabKey = props.defaultActiveTabKey,
    tabBarExtraContent = props.tabBarExtraContent,
    hoverable = props.hoverable,
    _props$tabProps = props.tabProps,
    tabProps = _props$tabProps === void 0 ? {} : _props$tabProps,
    bodyClassName = props.bodyClassName,
    headClassName = props.headClassName,
    others = _objectWithoutProperties(props, _excluded);
  var prefixCls = getPrefixCls("card", customizePrefixCls);
  var loadingBlock = /*#__PURE__*/_jsx(Skeleton, {
    loading: true,
    active: true,
    paragraph: {
      rows: 4
    },
    title: false,
    children: children
  });
  var hasActiveTabKey = activeTabKey !== undefined;
  var extraProps = _objectSpread(_objectSpread({}, tabProps), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, hasActiveTabKey ? "activeKey" : "defaultActiveKey", hasActiveTabKey ? activeTabKey : defaultActiveTabKey), _defineProperty(_objectSpread2, "tabBarExtraContent", tabBarExtraContent), _objectSpread2));
  var head;
  var tabs = tabList && tabList.length ? /*#__PURE__*/_jsx(Tabs, _objectSpread(_objectSpread({
    size: "large"
  }, extraProps), {}, {
    className: "".concat(prefixCls, "-head-tabs"),
    onChange: onTabChange,
    items: tabList.map(function (tab) {
      return {
        label: tab.tab,
        key: tab.key,
        disabled: tab.disabled
      };
    })
  })) : null;
  if (title || extra || tabs) {
    head = /*#__PURE__*/_jsxs("div", {
      className: classNames("".concat(prefixCls, "-head"), headClassName),
      style: headStyle,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-head-wrapper"),
        children: [title && /*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-head-title"),
          children: title
        }), extra && /*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-extra"),
          children: extra
        })]
      }), tabs]
    });
  }
  var coverDom = cover ? /*#__PURE__*/_jsx("div", {
    className: "".concat(prefixCls, "-cover"),
    children: cover
  }) : null;
  var body = /*#__PURE__*/_jsx("div", {
    className: classNames("".concat(prefixCls, "-body"), bodyClassName),
    style: bodyStyle,
    children: loading ? loadingBlock : children
  });
  var actionDom = actions && actions.length ? /*#__PURE__*/_jsx("ul", {
    className: "".concat(prefixCls, "-actions"),
    children: getAction(actions)
  }) : null;
  var divProps = omit(others, ["onTabChange"]);
  var mergedSize = customizeSize || size;
  var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), hoverable), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref
  }, divProps), {}, {
    className: classString,
    children: [head, coverDom, body, actionDom]
  }));
});
export default Card;